import { Link } from 'react-router'
import { Text } from '@mantine/core'
import clsx from 'clsx'
import { useCallback, useEffect, useRef } from 'react'
import classes from './Tabs.module.css'

export default function Tabs({
  items,
  value,
  onChange,
  isLink,
  isLarge,
  isSmall,
}: {
  items: Array<{ value: string; label: string }>
  value: string
  onChange: (value: string) => void
  isLink?: boolean
  isLarge?: boolean
  isSmall?: boolean
}) {
  const activeTabRef = useRef<HTMLElement | null>(null)

  const setActiveRef = useCallback((node: HTMLElement | null) => {
    activeTabRef.current = node
  }, [])

  useEffect(() => {
    const tab = activeTabRef.current
    const container = tab?.parentElement
    if (!tab || !container) return
    const tabRect = tab.getBoundingClientRect()
    const containerRect = container.getBoundingClientRect()
    const targetLeft =
      container.scrollLeft +
      (tabRect.left - containerRect.left) -
      (containerRect.width - tabRect.width) / 2
    container.scrollTo({ left: targetLeft, behavior: 'smooth' })
  }, [value])

  return (
    <div className={classes.container}>
      {items.map((item) =>
        isLink ? (
          <Link
            key={item.value}
            to={item.value}
            ref={item.value === value ? setActiveRef : null}
            className={clsx(
              classes.item,
              {
                [classes.selected]: item.value === value,
              },
              { [classes.large]: isLarge }
            )}
          >
            {item.label}
          </Link>
        ) : (
          <Text
            key={item.value}
            ref={item.value === value ? setActiveRef : null}
            className={clsx(
              classes.item,
              {
                [classes.selected]: item.value === value,
              },
              { [classes.large]: isLarge },
              { [classes.small]: isSmall }
            )}
            onClick={() => onChange(item.value)}
          >
            {item.label}
          </Text>
        )
      )}
    </div>
  )
}
